import React, { useState, useEffect } from "react";
import { useGenerateOrderNumber } from "../../../../../api/orders/orders";

const OrderInformation = ({ onNext }) => {
  const [orderNumber, setOrderNumber] = useState("");
  const [paymentType, setPaymentType] = useState("Prepaid");
  const [orderType, setOrderType] = useState("Forward");
  const [shipmentType, setShipmentType] = useState("Single");

  const [errors, setErrors] = useState({});

  const {
    data: generatedOrderNumber,
    isLoading,
    isError,
    refetch,
  } = useGenerateOrderNumber();

  // Auto-fill order number when generated
  useEffect(() => {
    if (generatedOrderNumber?.order_number) {
      setOrderNumber(generatedOrderNumber.order_number);
    }
  }, [generatedOrderNumber]);

  const validate = () => {
    const newErrors = {};

    if (!orderNumber || !orderNumber.trim()) {
      newErrors.orderNumber = "Order number is required.";
    }
    if (!paymentType) {
      newErrors.paymentType = "Payment type is required.";
    }
    if (!orderType) {
      newErrors.orderType = "Order type is required.";
    }
    if (!shipmentType) {
      newErrors.shipmentType = "Shipment type is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextClick = () => {
    if (!validate()) return;

    const data = {
      orderNumber: orderNumber.trim(),
      paymentType,
      orderType,
      shipmentType,
    };

    onNext(data);
  };

  return (
    <div className="border-b p-6">
      <h3 className="text-base font-semibold mb-4">Order Information</h3>

      {isLoading && (
        <p className="text-xs text-gray-500 mb-2">Loading order number...</p>
      )}
      {isError && (
        <div className="text-xs text-red-500 mb-2">
          Failed to generate order number.
          <button onClick={refetch} className="ml-2 text-blue-500 underline">
            Retry
          </button>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="col-span-2">
          <label className="block text-md font-medium mb-1">
            Customer Order Number <span className="text-red-500">*</span>
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              placeholder="Enter order number"
              className={`flex-1 border px-3 py-2 rounded text-sm ${
                errors.orderNumber ? "border-red-500" : "border-gray-300"
              }`}
            />
          </div>
          {errors.orderNumber && (
            <p className="text-red-500 text-xs mt-1">{errors.orderNumber}</p>
          )}
        </div>

        <div className="col-span-2">
          <label className="block text-md font-medium mb-1">
            Payment Type <span className="text-red-500">*</span>
          </label>
          <select
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
            className={`w-full border px-3 py-2 rounded text-sm ${
              errors.paymentType ? "border-red-500" : "border-gray-300"
            }`}
          >
            <option value="Prepaid">Prepaid</option>
            <option value="COD">COD</option>
          </select>
          {errors.paymentType && (
            <p className="text-red-500 text-xs mt-1">{errors.paymentType}</p>
          )}
        </div>

        <div className="col-span-2">
          <label className="block text-md font-medium mb-1">
            Order Type <span className="text-red-500">*</span>
          </label>
          <div className="flex items-center space-x-4 text-sm">
            <label className="flex items-center">
              <input
                type="radio"
                name="orderType"
                value="Forward"
                checked={orderType === "Forward"}
                onChange={(e) => setOrderType(e.target.value)}
                className="mr-2"
                disabled
                readOnly
              />
              Forward
            </label>
          </div>
          {errors.orderType && (
            <p className="text-red-500 text-xs mt-1">{errors.orderType}</p>
          )}
        </div>

        <div className="col-span-2">
          <label className="block text-md font-medium mb-1">
            Shipment Type <span className="text-red-500">*</span>
          </label>
          <div className="flex items-center space-x-4 text-sm">
            <label className="flex items-center">
              <input
                type="radio"
                name="shipmentType"
                value="Single"
                checked={shipmentType === "Single"}
                onChange={(e) => setShipmentType(e.target.value)}
                className="mr-2"
                disabled
                readOnly
              />
              Single
            </label>
          </div>
          {errors.shipmentType && (
            <p className="text-red-500 text-xs mt-1">{errors.shipmentType}</p>
          )}
        </div>
      </div>

      <div className="mt-6 text-right">
        <button
          onClick={handleNextClick}
          disabled={isLoading}
          className="bg-primaryLight hover:bg-primary text-primary border border-primary hover:text-white px-6 py-2 rounded text-sm disabled:opacity-50"
        >
          NEXT
        </button>
      </div>
    </div>
  );
};

export default OrderInformation;
